import { render } from "./Sanchan2.vue?vue&type=template&id=0101550c&scoped=true"
import script from "./Sanchan2.vue?vue&type=script&lang=js"
export * from "./Sanchan2.vue?vue&type=script&lang=js"

import "./Sanchan2.vue?vue&type=style&index=0&id=0101550c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0101550c"

export default script